<template>
  <el-dialog :visible.sync="show" :modal="true" width="38%" custom-class="custom-dialog" :close-on-click-modal="false" :append-to-body="true">
    <div slot="title" class="title">
      <div class="title-name">{{ title }}</div>
      <div class="side-title"></div>
      <div class="handle-btn"><!-- <i class="el-icon-s-tools" slot="reference" style="cursor:pointer"></i> --></div>
    </div>
    <div class="upload-wapper">
      <div v-if="!type" class="mb10 flex-row item-center">
        <div class="mr10 el-alert--success">选择文件类型：</div>
        <el-select v-model="fileType" class="mr10" filterable size="mini" placeholder="请选择">
          <el-option v-for="val in fileTypes" :key="val" :label="val" :value="val"></el-option>
        </el-select>
      </div>

      <!-- 搜索框上边的 -->
      <slot name="header"></slot>

      <el-upload
        ref="upload"
        :action="uploadUrl"
        :on-success="afterSuccess"
        :on-error="handleError"
        :data="{ type: type || fileType }"
        :on-change="onChange"
        :limit="limit"
        :on-progress="progressFunc"
        :on-exceed="onExceed"
        :before-upload="beforeUpload"
        drag
        with-credentials
        multiple
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">
          {{ errors.length > 0 ? '胜败乃兵家常事，少侠请从新来过' : '关闭窗口，文件会在后台上传' }}
          <span class="luxun">-- 鲁迅</span>
        </div>
        <div v-for="(err, index) in errors" slot="tip" :key="err.file" class="el-upload__tip">
          <span class="error-name">{{ err.file }}</span> <span class="error-msg">{{ err.message }}</span>
          <span class="error luxun" @click="removeError(index)">无视它</span>
        </div>
      </el-upload>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-tooltip effect="light" content="此操作会中止正在上传的文件" placement="top">
        <el-button type="danger" size="medium" icon="el-icon-delete" @click="clean">清空列表</el-button>
      </el-tooltip>
    </span>
  </el-dialog>
</template>

<script>
import { fileTypes } from '../../../project/src/constant/type'

export default {
  props: {
    type: { type: String, default: '' },
    label: { type: String, default: undefined },
    title: { type: String, default: '上传' },
    limit: { type: Number, default: undefined },
    onSuccess: { type: Function, default: () => {} },
    onError: { type: Function, default: () => {} },
    onExceed: { type: Function, default: () => {} },
    onProgress: { type: Function, default: () => {} },
    url: { type: String, default: 'uploads' },
    beforeUpload: {
      type: Function,
      default: () => true,
    },
  },
  data() {
    return {
      uploadUrl: `${window.host}/uploads`,
      show: false,
      uploadingFiles: [],
      errors: [],
      fileType: '',
      assignObjArr: [],
    }
  },
  computed: {
    fileTypes() {
      return fileTypes
    },
  },
  watch: {
    url: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.uploadUrl = `${window.host}/${newValue}`
        }
      },
      immediate: true,
    },
  },
  methods: {
    clean() {
      this.errors = []
      this.$refs.upload && this.$refs.upload.clearFiles()
    },
    visible(val,assignObj) {
      this.show = val
      this.assignObj = assignObj || {}
      if (val) this.fileType = ''
    },
    progressFunc(event, file, fileList){
      this.onProgress(event, file, fileList)
      this.assignObjArr.push({uid:file.uid,obj:this.assignObj})
    },
    onChange(file, fileList) {
      const { label, fileType } = this
      const _label = label || fileType
      if (_label) {
        const uploadingFiles = this.uploadingFiles
        const index = uploadingFiles.findIndex(val => file.uid === val)
        if (index === -1) {
          file.name = `( ${_label} ) ${file.name}`
          uploadingFiles.push(file.uid)
        }
      }
    },
    handleError(err, file, fileList) {
      this.errors.push({
        file: file.name,
        message: err.message,
      })
      this.onError(err, file, fileList)
    },
    removeError(index) {
      this.errors.splice(index, 1)
    },
    afterSuccess(response, file, fileList) {
      const obj = this.assignObjArr.find(a=>a.uid===file.uid)
      this.onSuccess(response, file, fileList, obj && obj.obj)
      this.$emit('uploaded', response)
    },
  },
}
</script>

<style>
.upload-wapper .el-upload,
.upload-wapper .el-upload-dragger {
  width: 100%;
}
.upload-type {
  margin: 0 0 10px 0;
}
.el-upload__tip {
  position: relative;
  padding-right: 38px;
}
.luxun {
  position: absolute;
  right: 0;
  top: 0;
}
.error-name {
  color: #f56c6c;
}
.error-msg {
  color: #909399;
}
.error:hover {
  color: #f56c6c;
  cursor: pointer;
}
</style>
